import React from "react";
import "./UntagAllButton.css";

interface Props {
  /** How many placed activities would be untagged (0 → nothing to do, hidden). */
  count: number;
  /** "section" | "zone" | "level" — names the container in the prompt/tooltip. */
  scope: string;
  /** Untag those activities (host keeps the empty zone/level structure). */
  onConfirm: () => void;
}

const stop = (e: React.SyntheticEvent) => e.stopPropagation();

/** A deliberate, confirmed "untag everything in this container" control. Untags
 *  the activities (back to the untagged rail) but never removes the zone/level
 *  row itself — that structure is kept by the host. */
const UntagAllButton: React.FC<Props> = ({ count, scope, onConfirm }) => {
  const [confirming, setConfirming] = React.useState(false);

  if (count === 0) return null;

  if (confirming) {
    return (
      <span className="takt-editor-untagall-confirm" onClick={stop}>
        <span className="takt-editor-untagall-prompt">
          Untag {count} {count === 1 ? "activity" : "activities"}?
        </span>
        <button
          type="button"
          className="takt-editor-untagall-yes"
          onClick={(e) => {
            stop(e);
            setConfirming(false);
            onConfirm();
          }}
        >
          Untag
        </button>
        <button
          type="button"
          className="takt-editor-untagall-no"
          onClick={(e) => {
            stop(e);
            setConfirming(false);
          }}
        >
          Cancel
        </button>
      </span>
    );
  }

  return (
    <button
      type="button"
      className="takt-editor-untagall-btn"
      title={`Untag all activities in this ${scope} — drops their code + placement, back to the untagged rail (the ${scope} row stays)`}
      onClick={(e) => {
        stop(e);
        setConfirming(true);
      }}
    >
      Untag all
    </button>
  );
};

export default UntagAllButton;
